import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import { useTranslation } from 'react-i18next';

export function CookieConsent(): JSX.Element {
  const { t } = useTranslation();
  const cookieName = 'consentCookies';
  const expires = 30;
  const [visible, setVisible] = useState(false);

  const onAccept = (): void => {
    Cookies.set(cookieName, 'true', { expires });
    setVisible(false);
  };

  useEffect(() => {
    if (!Cookies.get(cookieName)) {
      setVisible(true);
    }
  }, []);

  return (
    <>
      {visible && (
        <div className='CookieConsent fixed-bottom py-3'>
          <div className='row cookie-container'>
            <div className='col align-items-center'>
              <p className='m-0'>
                {t('cookies.message')}
&nbsp;
                <a
                  className='cookie-link'
                  target='_blank'
                  rel='noopener noreferrer'
                  href={t('cookies.privacy-policy-link')}
                >
                  {t('cookies.privacy-policy')}
                </a>
                .
              </p>
            </div>
            <div className='buttons-container'>
              <button type='button' className='btn btn-light' onClick={onAccept}>
                {t('button.accept')}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
